<template>
  <section
    v-if="!isNative && os !== 'Other'"
    class="NativeBannerView"
    data-testid="nativeBanner"
    @click="handleViewClick"
  >
    <div class="NativeBannerView__icon">
      <Basketball class="NativeBannerView__basketball" />
    </div>
    <div class="NativeBannerView__content">
      <h3 class="NativeBannerView__title">
        Ball.app for {{ os }}
      </h3>
      <p class="NativeBannerView__subtitle">
        Install the native app
      </p>
    </div>
    <FormButton
      size="small"
      shape="round"
    >
      Get
    </FormButton>
  </section>
</template>

<script lang="ts" setup>
import Basketball from "@/components/Basketball.vue";
import FormButton from "@/components/FormButton.vue";
import detectOS from "@/lib/utils/platform/detectOS";
import { OS } from "@/lib/utils/platform/detectOS.types";
import isNative from "@/lib/utils/platform/isNative";
import { computed } from "vue";

const os = computed(() => {
  switch (detectOS()) {
    case OS.iOS:
      return "iOS";
    case OS.android:
      return "Android";
  }

  return "Other";
});

const appStoreUrl = computed(() => {
  return detectOS() === OS.iOS
    ? "https://testflight.apple.com/join/ph4Exqn7"
    : "https://play.google.com/store/apps/details?id=app.bball.prod&hl=en-US&ah=lSaUOraM74cPWHuKzL3wxDSISkc";
});

function handleViewClick () {
  window.location.href = appStoreUrl.value;
}
</script>

<style lang="scss" scoped>
.NativeBannerView {
  display: grid;
  grid: auto / min-content auto min-content;
  gap: 10px;
  align-items: center;
  padding: 16px 12px;

  border-bottom: solid 1px var(--themeLightTransparent150);
}

.NativeBannerView__icon {
  display: grid;
  place-items: center;
  width: 64px;
  aspect-ratio: 1;

  border: solid 1px var(--themeLightTransparent200);
  border-radius: 14px;

  cursor: pointer;
}

.NativeBannerView__basketball {
  width: 44px;
  height: 44px;

  border-radius: 50%;
  box-shadow: 0 0 0 3px var(--themeColorNeutral0);
}

.NativeBannerView__content {
  display: grid;
  gap: 4px;
}

.NativeBannerView__title {
  color: var(--themeColorNeutral0);
  font: var(--fontWeightMedium) 18px / 1.2 var(--fontFamilyNormal);
  font-stretch: var(--fontWidthExtended);
}

.NativeBannerView__subtitle {
  color: var(--themeLightTransparent700);
  font: var(--fontWeightNormal) 14px / 1 var(--fontFamilyNormal);
  font-stretch: var(--fontWidthExtended);
}
</style>
